export default function Space({ size = "10px", horizontal = false, style }) {
    let overrideStyle = { ...style };
    if (horizontal) overrideStyle.width = size;
    else overrideStyle.height = size;
    return (
        <div style={overrideStyle}></div>
    )
}